import Controller from '../abstracts/Controller';
import 'scss-templates/t-listing.scss';

export default class ListingController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'PaginationComponent',
      'SeoTextComponent',
      'TripleImageTextComponent',
      'O2OComponent',
      'EditorialButterflyComponent',
      'SimpleBarComponent',
      'GeneralComponentsComponent',
      'WishlistComponent',
      'AddToWishlistComponent',
      'VisualMerchandaisingComponent',
      'HistoryManagerComponent',
      'CategoryFilterComponent',
      'SalesMacroCategoryComponent'
    ];
  }
}
